export function isFinalNightLive(c) {
  return c?.final_night_status === "live";
}

export function isRunningLive(c) {
  return c?.status === "running" && !isFinalNightLive(c);
}

/** Live = Final Night live or competition running */
export function isLiveCompetition(c) {
  return isFinalNightLive(c) || isRunningLive(c);
}

function createdAtTime(c) {
  return new Date(c?.createdAt || c?.created_at || c?.start_date || 0).getTime();
}

/** 0 = Final Night live, 1 = running, 2 = everything else */
function listingTier(c) {
  if (isFinalNightLive(c)) return 0;
  if (c?.status === "running") return 1;
  return 2;
}

/**
 * Final Night live first (newest createdAt),
 * then running live (newest createdAt),
 * then other visible competitions (newest createdAt).
 */
export function sortCompetitionsForListing(list) {
  return [...(list || [])].sort((a, b) => {
    const tierDiff = listingTier(a) - listingTier(b);
    if (tierDiff !== 0) return tierDiff;
    return createdAtTime(b) - createdAtTime(a);
  });
}

export function partitionCompetitionsForListing(list) {
  const sorted = sortCompetitionsForListing(list);
  const live = sorted.filter(isLiveCompetition);
  const other = sorted.filter((c) => !isLiveCompetition(c));
  return { live, other, all: sorted };
}
